// Recovered compiled webpack factory 77217. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { f: () => td });
  var n = i(27290),
    s = i(40042),
    r = i(6500),
    o = i(27424),
    a = i(23656),
    l = i(48895),
    h = i(62213),
    u = i(45130),
    d = i(73934);
  let c = (t) => {
    let e = ({ timestamp: e }) => t(e);
    return {
      start: (t = !0) => d.Gt.update(e, t),
      stop: () => (0, d.WG)(e),
      now: () => (d.uv.isProcessing ? d.uv.timestamp : o.k.now()),
    };
  };
  var p = i(72980),
    m = i(45242);
  function f(t, e, i) {
    let n = Math.max(e - 5, 0);
    return (0, m.f)(i - t(n), e - n);
  }
  function v({
    keyframes: t,
    velocity: e = 0,
    power: i = 0.8,
    timeConstant: n = 325,
    bounceDamping: s = 10,
    bounceStiffness: r = 500,
    modifyTarget: o,
    min: a,
    max: l,
    restDelta: h = 0.5,
    restSpeed: u,
  }) {
    let d,
      c,
      m = t[0],
      v = { done: !1, value: m },
      y = i * e,
      g = m + y,
      x = void 0 === o ? g : o(g);
    x !== g && (y = x - m);
    let w = (t) => -y * Math.exp(-t / n),
      T = (t) => x + w(t),
      b = (t) => {
        let e = w(t),
          i = T(t);
        ((v.done = Math.abs(e) <= h), (v.value = v.done ? x : i));
      },
      S = (t) => {
        let e;
        if (((e = v.value), (void 0 !== a && e < a) || (void 0 !== l && e > l))) {
          var i;
          ((d = t),
            (c = (0, p.o)({
              keyframes: [
                v.value,
                ((i = v.value),
                void 0 === a ? l : void 0 === l || Math.abs(a - i) < Math.abs(l - i) ? a : l),
              ],
              velocity: f(T, t, v.value),
              damping: s,
              stiffness: r,
              restDelta: h,
              restSpeed: u,
            })));
        }
      };
    return (
      S(0),
      {
        calculatedDuration: null,
        next: (t) => {
          let e = !1;
          return (c || void 0 !== d || ((e = !0), b(t), S(t)), void 0 !== d && t >= d)
            ? c.next(t - d)
            : (e || b(t), v);
        },
      }
    );
  }
  let y = (t, e, i) => (((1 - 3 * i + 3 * e) * t + (3 * i - 6 * e)) * t + 3 * e) * t;
  function g(t, e, i, n) {
    return t === e && i === n
      ? r.l
      : (s) =>
          0 === s || 1 === s
            ? s
            : y(
                (function (t, e, i, n, s) {
                  let r,
                    o,
                    a = 0;
                  do (r = y((o = e + (i - e) / 2), n, s) - t) > 0 ? (i = o) : (e = o);
                  while (Math.abs(r) > 1e-7 && ++a < 12);
                  return o;
                })(s, 0, 1, t, i),
                e,
                n,
              );
  }
  let x = g(0.42, 0, 1, 1),
    w = g(0, 0, 0.58, 1),
    T = g(0.42, 0, 0.58, 1);
  var b = i(55038),
    S = i(78041),
    P = i(95516),
    A = i(16815);
  let E = g(0.33, 1.53, 0.69, 0.99),
    M = (0, A.G)(E),
    k = (0, P.V)(M),
    V = (t) => (t >= 1 ? 1 : (t *= 2) < 1 ? 0.5 * M(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))));
  var C = i(69809),
    D = i(34324);
  let R = {
      linear: r.l,
      easeIn: x,
      easeInOut: T,
      easeOut: w,
      circIn: C.po,
      circInOut: C.tn,
      circOut: C.yT,
      backIn: M,
      backInOut: k,
      backOut: E,
      anticipate: V,
    },
    L = (t) => {
      if ((0, D.D)(t)) {
        (0, S.V)(
          4 === t.length,
          "Cubic bezier arrays must contain four numerical values.",
          "cubic-bezier-length",
        );
        let [e, i, n, s] = t;
        return g(e, i, n, s);
      }
      return "string" == typeof t
        ? ((0, S.V)(void 0 !== R[t], `Invalid easing type '${t}'`, "invalid-easing-type"), R[t])
        : t;
    };
  var j = i(16706),
    B = i(44554);
  function F({ duration: t = 300, keyframes: e, times: i, ease: n = "easeInOut" }) {
    var s;
    let r = (0, b.h)(n) ? n.map(L) : L(n),
      o = { done: !1, value: e[0] },
      a = ((s = i && i.length === e.length ? i : (0, B.Z)(e)), s.map((e) => e * t)),
      l = (0, j.G)(a, e, {
        ease: Array.isArray(r) ? r : e.map(() => r || T).splice(0, e.length - 1),
      });
    return { calculatedDuration: t, next: (e) => ((o.value = l(e)), (o.done = e >= t), o) };
  }
  var I = i(38857),
    O = i(33855);
  let U = { decay: v, inertia: v, tween: F, keyframes: F, spring: p.o };
  function W(t) {
    "string" == typeof t.type && (t.type = U[t.type]);
  }
  var N = i(87671);
  let $ = (t) => t / 100;
  class G extends N.q {
    constructor(t) {
      (super(),
        (this.state = "idle"),
        (this.startTime = null),
        (this.isStopped = !1),
        (this.currentTime = 0),
        (this.holdTime = null),
        (this.playbackSpeed = 1),
        (this.delayState = { done: !1, value: void 0 }),
        (this.stop = () => {
          let { motionValue: t } = this.options;
          (t && t.updatedAt !== o.k.now() && this.tick(o.k.now()),
            (this.isStopped = !0),
            "idle" !== this.state && (this.teardown(), this.options.onStop?.()));
        }),
        h.q.mainThread++,
        (this.options = t),
        this.initAnimation(),
        this.play(),
        !1 === t.autoplay && this.pause());
    }
    initAnimation() {
      let { options: t } = this;
      W(t);
      let { type: e = F, repeat: i = 0, repeatDelay: n = 0, repeatType: s, velocity: r = 0 } = t,
        { keyframes: o } = t,
        l = e || F;
      l !== F &&
        "number" != typeof o[0] &&
        ((this.mixKeyframes = (0, a.F)($, (0, u.j)(o[0], o[1]))), (o = [0, 100]));
      let h = l({ ...t, keyframes: o });
      ("mirror" === s &&
        (this.mirroredGenerator = l({ ...t, keyframes: [...o].reverse(), velocity: -r })),
        null === h.calculatedDuration && (h.calculatedDuration = (0, I.t)(h)));
      let { calculatedDuration: d } = h;
      ((this.calculatedDuration = d),
        (this.resolvedDuration = d + n),
        (this.totalDuration = this.resolvedDuration * (i + 1) - n),
        (this.generator = h));
    }
    updateTime(t) {
      let e = Math.round(t - this.startTime) * this.playbackSpeed;
      null !== this.holdTime ? (this.currentTime = this.holdTime) : (this.currentTime = e);
    }
    tick(t, e = !1) {
      let i,
        {
          generator: n,
          totalDuration: s,
          mixKeyframes: r,
          mirroredGenerator: o,
          resolvedDuration: a,
          calculatedDuration: h,
        } = this;
      if (null === this.startTime) return n.next(0);
      let {
        delay: u = 0,
        keyframes: d,
        repeat: c,
        repeatType: p,
        repeatDelay: m,
        type: f,
        onUpdate: y,
        finalKeyframe: g,
      } = this.options;
      (this.speed > 0
        ? (this.startTime = Math.min(this.startTime, t))
        : this.speed < 0 && (this.startTime = Math.min(t - s / this.speed, this.startTime)),
        e ? (this.currentTime = t) : this.updateTime(t));
      let x = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1),
        w = this.playbackSpeed >= 0 ? x < 0 : x > s;
      ((this.currentTime = Math.max(x, 0)),
        "finished" === this.state && null === this.holdTime && (this.currentTime = s));
      let T = this.currentTime,
        b = n;
      if (c) {
        let t = Math.min(this.currentTime, s) / a,
          e = Math.floor(t),
          i = t % 1;
        (!i && t >= 1 && (i = 1),
          1 === i && e--,
          (e = Math.min(e, c + 1)) % 2 &&
            ("reverse" === p ? ((i = 1 - i), m && (i -= m / a)) : "mirror" === p && (b = o)),
          (T = (0, l.q)(0, 1, i) * a));
      }
      (w ? ((this.delayState.value = d[0]), (i = this.delayState)) : (i = b.next(T)),
        r && !w && (i.value = r(i.value)));
      let { done: S } = i;
      w ||
        null === h ||
        (S = this.playbackSpeed >= 0 ? this.currentTime >= s : this.currentTime <= 0);
      let P =
        null === this.holdTime && ("finished" === this.state || ("running" === this.state && S));
      return (
        P && f !== v && (i.value = (0, O.X)(d, this.options, g, this.speed)),
        y && y(i.value),
        P && this.finish(),
        i
      );
    }
    then(t, e) {
      return this.finished.then(t, e);
    }
    get duration() {
      return (0, n.X)(this.calculatedDuration);
    }
    get iterationDuration() {
      let { delay: t = 0 } = this.options || {};
      return this.duration + (0, n.X)(t);
    }
    get time() {
      return (0, n.X)(this.currentTime);
    }
    set time(t) {
      ((t = (0, n.f)(t)),
        (this.currentTime = t),
        null === this.startTime || null !== this.holdTime || 0 === this.playbackSpeed
          ? (this.holdTime = t)
          : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed),
        this.driver
          ? this.driver.start(!1)
          : ((this.startTime = 0), (this.state = "paused"), (this.holdTime = t), this.tick(t)));
    }
    getGeneratorVelocity() {
      let t = this.currentTime;
      if (t <= 0) return this.options.velocity || 0;
      if (this.generator.velocity) return this.generator.velocity(t);
      let e = this.generator.next(t).value;
      return f((t) => this.generator.next(t).value, t, e);
    }
    get speed() {
      return this.playbackSpeed;
    }
    set speed(t) {
      let e = this.playbackSpeed !== t;
      (e && this.driver && this.updateTime(o.k.now()),
        (this.playbackSpeed = t),
        e && this.driver && (this.time = (0, n.X)(this.currentTime)));
    }
    play() {
      if (this.isStopped) return;
      let { driver: t = c, startTime: e } = this.options;
      (this.driver || (this.driver = t((t) => this.tick(t))), this.options.onPlay?.());
      let i = this.driver.now();
      ("finished" === this.state
        ? (this.updateFinished(), (this.startTime = i))
        : null !== this.holdTime
          ? (this.startTime = i - this.holdTime)
          : this.startTime || (this.startTime = e ?? i),
        "finished" === this.state && this.speed < 0 && (this.startTime += this.calculatedDuration),
        (this.holdTime = null),
        (this.state = "running"),
        this.driver.start());
    }
    pause() {
      ((this.state = "paused"), this.updateTime(o.k.now()), (this.holdTime = this.currentTime));
    }
    complete() {
      ("running" !== this.state && this.play(), (this.state = "finished"), (this.holdTime = null));
    }
    finish() {
      (this.notifyFinished(),
        this.teardown(),
        (this.state = "finished"),
        this.options.onComplete?.());
    }
    cancel() {
      ((this.holdTime = null),
        (this.startTime = 0),
        this.tick(0),
        this.teardown(),
        this.options.onCancel?.());
    }
    teardown() {
      ((this.state = "idle"),
        this.stopDriver(),
        (this.startTime = this.holdTime = null),
        h.q.mainThread--);
    }
    stopDriver() {
      this.driver && (this.driver.stop(), (this.driver = void 0));
    }
    sample(t) {
      return ((this.startTime = 0), this.tick(t, !0));
    }
    attachTimeline(t) {
      return (
        this.options.allowFlatten &&
          ((this.options.type = "keyframes"), (this.options.ease = "linear"), this.initAnimation()),
        this.driver?.stop(),
        t.observe(this)
      );
    }
  }
  var X = i(63946),
    q = i(46934),
    K = i(82617);
  let H = { anticipate: V, backInOut: k, circInOut: C.tn };
  class z extends K.m {
    constructor(t) {
      (!(function (t) {
        "string" == typeof t.ease && t.ease in H && (t.ease = H[t.ease]);
      })(t),
        W(t),
        super(t),
        void 0 !== t.startTime && !1 !== t.autoplay && (this.startTime = t.startTime),
        (this.options = t));
    }
    updateMotionValue(t) {
      let { motionValue: e, onUpdate: i, onComplete: n, element: s, ...r } = this.options;
      if (!e) return;
      if (void 0 !== t) return void e.set(t);
      let a = new G({ ...r, autoplay: !1 }),
        h = Math.max(10, o.k.now() - this.startTime),
        u = (0, l.q)(0, 10, h - 10),
        d = a.sample(h).value,
        { name: c } = this.options;
      (s && c && (0, q.e)(s, c, d),
        e.setWithVelocity(a.sample(Math.max(0, h - u)).value, d, u),
        a.stop());
    }
  }
  var Y = i(65181),
    Q = i(24888);
  let _ = (t, e) =>
    "zIndex" !== e &&
    !!(
      "number" == typeof t ||
      Array.isArray(t) ||
      ("string" == typeof t && (Q.f.test(t) || "0" === t) && !t.startsWith("url("))
    );
  function Z(t) {
    ((t.duration = 0), (t.type = "keyframes"));
  }
  var J = i(60178),
    tt = i(87913);
  let te = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/,
    ti = new Set([
      "color",
      "backgroundColor",
      "outlineColor",
      "fill",
      "stroke",
      "borderColor",
      "borderTopColor",
      "borderRightColor",
      "borderBottomColor",
      "borderLeftColor",
    ]),
    tn = (0, J.p)(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
  class ts extends N.q {
    constructor({
      autoplay: t = !0,
      delay: e = 0,
      type: i = "keyframes",
      repeat: n = 0,
      repeatDelay: s = 0,
      repeatType: r = "loop",
      keyframes: a,
      name: l,
      motionValue: h,
      element: u,
      ...d
    }) {
      (super(),
        (this.stop = () => {
          (this._animation && (this._animation.stop(), this.stopTimeline?.()),
            this.keyframeResolver?.cancel());
        }),
        (this.createdAt = o.k.now()));
      let c = {
          autoplay: t,
          delay: e,
          type: i,
          repeat: n,
          repeatDelay: s,
          repeatType: r,
          name: l,
          motionValue: h,
          element: u,
          ...d,
        },
        p = u?.KeyframeResolver || X.h;
      ((this.keyframeResolver = new p(
        a,
        (t, e, i) => this.onKeyframesResolved(t, e, c, !i),
        l,
        h,
        u,
      )),
        this.keyframeResolver?.scheduleResolve());
    }
    onKeyframesResolved(t, e, i, n) {
      let a;
      this.keyframeResolver = void 0;
      let { name: l, type: h, velocity: u, delay: d, isHandoff: c, onUpdate: p } = i;
      this.resolvedAt = o.k.now();
      let m = !0;
      !(function (t, e, i, n) {
        let s = t[0];
        if (null === s) return !1;
        if ("display" === e || "visibility" === e) return !0;
        let r = t[t.length - 1],
          o = _(s, e),
          a = _(r, e);
        return (
          (0, S.$)(
            o === a,
            `You are trying to animate ${e} from "${s}" to "${r}". "${o ? r : s}" is not an animatable value.`,
            "value-not-animatable",
          ),
          !!o &&
            !!a &&
            ((function (t) {
              let e = t[0];
              if (1 === t.length) return !0;
              for (let i = 0; i < t.length; i++) if (t[i] !== e) return !0;
            })(t) ||
              (("spring" === i || (0, Y.W)(i)) && n))
        );
      })(t, l, h, u) &&
        ((m = !1),
        (s.W.instantAnimations || !d) && p?.((0, O.X)(t, i, e)),
        (t[0] = t[t.length - 1]),
        Z(i),
        (i.repeat = 0));
      let f = {
          startTime: n
            ? this.resolvedAt && this.resolvedAt - this.createdAt > 40
              ? this.resolvedAt
              : this.createdAt
            : void 0,
          finalKeyframe: e,
          ...i,
          keyframes: t,
        },
        v =
          m &&
          !c &&
          (function (t) {
            let {
              motionValue: e,
              name: i,
              repeatDelay: n,
              repeatType: s,
              damping: r,
              type: o,
              keyframes: a,
            } = t;
            if (!(e?.owner?.current instanceof HTMLElement)) return !1;
            let { onUpdate: l, transformTemplate: h } = e.owner.getProps();
            return (
              tn() &&
              i &&
              (tt.M.has(i) ||
                (ti.has(i) &&
                  (function (t) {
                    for (let e = 0; e < t.length; e++)
                      if ("string" == typeof t[e] && te.test(t[e])) return !0;
                    return !1;
                  })(a))) &&
              ("transform" !== i || !h) &&
              !l &&
              !n &&
              "mirror" !== s &&
              0 !== r &&
              "inertia" !== o
            );
          })(f),
        y = f.motionValue?.owner?.current;
      if (v)
        try {
          a = new z({ ...f, element: y });
        } catch {
          a = new G(f);
        }
      else a = new G(f);
      (a.finished
        .then(() => {
          this.notifyFinished();
        })
        .catch(r.l),
        this.pendingTimeline &&
          ((this.stopTimeline = a.attachTimeline(this.pendingTimeline)),
          (this.pendingTimeline = void 0)),
        (this._animation = a));
    }
    get finished() {
      return this._animation ? this.animation.finished : this._finished;
    }
    then(t, e) {
      return this.finished.finally(t).then(() => {});
    }
    get animation() {
      return (this._animation || (this.keyframeResolver?.resume(), (0, X.q)()), this._animation);
    }
    get duration() {
      return this.animation.duration;
    }
    get iterationDuration() {
      return this.animation.iterationDuration;
    }
    get time() {
      return this.animation.time;
    }
    set time(t) {
      this.animation.time = t;
    }
    get speed() {
      return this.animation.speed;
    }
    get state() {
      return this.animation.state;
    }
    set speed(t) {
      this.animation.speed = t;
    }
    get startTime() {
      return this.animation.startTime;
    }
    attachTimeline(t) {
      return (
        this._animation
          ? (this.stopTimeline = this.animation.attachTimeline(t))
          : (this.pendingTimeline = t),
        () => this.stop()
      );
    }
    play() {
      this.animation.play();
    }
    pause() {
      this.animation.pause();
    }
    complete() {
      this.animation.complete();
    }
    cancel() {
      (this._animation && this.animation.cancel(), this.keyframeResolver?.cancel());
    }
  }
  var tr = i(63354),
    to = i(40479);
  let ta = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 },
    tl = { type: "keyframes", duration: 0.8 },
    th = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 },
    tu = new Set([
      "when",
      "delay",
      "delayChildren",
      "staggerChildren",
      "staggerDirection",
      "repeat",
      "repeatType",
      "repeatDelay",
      "from",
      "elapsed",
    ]),
    td =
      (t, e, i, r = {}, o, a) =>
      (l) => {
        let h = (0, tr.r)(r, t) || {},
          u = h.delay || r.delay || 0,
          { elapsed: c = 0 } = r;
        c -= (0, n.f)(u);
        let p = {
          keyframes: Array.isArray(i) ? i : [null, i],
          ease: "easeOut",
          velocity: e.getVelocity(),
          ...h,
          delay: -c,
          onUpdate: (t) => {
            (e.set(t), h.onUpdate && h.onUpdate(t));
          },
          onComplete: () => {
            (l(), h.onComplete && h.onComplete());
          },
          name: t,
          motionValue: e,
          element: a ? void 0 : o,
        };
        (!(function (t) {
          for (let e in t) if (!tu.has(e)) return !0;
          return !1;
        })(h) &&
          Object.assign(
            p,
            ((t, { keyframes: e }) =>
              e.length > 2
                ? tl
                : to.f.has(t)
                  ? t.startsWith("scale")
                    ? {
                        type: "spring",
                        stiffness: 550,
                        damping: 0 === e[1] ? 2 * Math.sqrt(550) : 30,
                        restSpeed: 10,
                      }
                    : ta
                  : th)(t, p),
          ),
          p.duration && (p.duration = (0, n.f)(p.duration)),
          p.repeatDelay && (p.repeatDelay = (0, n.f)(p.repeatDelay)),
          void 0 !== p.from && (p.keyframes[0] = p.from));
        let m = !1;
        if (
          ((!1 !== p.type && (0 !== p.duration || p.repeatDelay)) ||
            (Z(p), 0 === p.delay && (m = !0)),
          (s.W.instantAnimations || s.W.skipAnimations || o?.shouldSkipAnimations) &&
            ((m = !0), Z(p), (p.delay = 0)),
          (p.allowFlatten = !h.type && !h.ease),
          m && !a && void 0 !== e.get())
        ) {
          let t = (0, O.X)(p.keyframes, h);
          if (void 0 !== t)
            return void d.Gt.update(() => {
              (p.onUpdate(t), p.onComplete());
            });
        }
        return h.isSync ? new G(p) : new ts(p);
      };
}
